<template>
  <section id="create-project-container">
    <Project />
  </section>
</template>

<script>
import Project from "@/views/projects/Project.vue";
import { mapMutations } from "vuex";
import CONSTANTS from "@/constants";
export default {
  name: "CreateProject",
  components: {
    Project,
  },
  computed: {},
  methods: {
    ...mapMutations("project", ["SET_PROJECT_MODE", "SET_TYPE_OF_PROJECT"]),
  },

  created() {
    this.SET_TYPE_OF_PROJECT(this.$route.params.type_of_project);
    this.SET_PROJECT_MODE(CONSTANTS.PROJECT_MODES.CREATE);
  },
};
</script>

<style lang="scss" scoped>
#create-project-container {
  margin: 0;
}
</style>